

export interface DesconsolidationType {
  "id": number,
  "name": string,
  "isActive": boolean
}
